<template>
  <div class="container">
    <router-view />
    <Breadcrumb :items="breadcrumbs" />
    <Invoice
      :invoiceId="invoiceId"
      :userId="$store.getters.getUser.id"
      scope="user"
    />
  </div>
</template>

<script>
import Invoice from "@/components/invoice/Invoice";
import { Breadcrumb } from "@/components";

export default {
  components: {
    Breadcrumb,
    Invoice
  },
  computed: {
    invoiceId() {
      return this.$route.params.invoiceId;
    }
  },
  data() {
    return {
      breadcrumbs: [
        { path: "/user", name: "Home" },
        { path: "/user/orders", name: "Orders" },
        { path: "", name: "Invoice" }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.colorGray {
  color: #a1a1a1;
}
</style>
